import React from "react";
import MuiPagination from "@mui/material/Pagination";

import {
  usePaginationStyles,
  usePaginationItemStyles,
} from "./Pagination.styles";
import { PaginationProps } from "./Pagination.types";
import { PaginationItem, PaginationRenderItemParams } from "@mui/material";
import ChevronBigLeft from "@tiny/icons/generated/ChevronBigLeft";
import ChevronBigRight from "@tiny/icons/generated/ChevronBigRight";

function Pagination(props: PaginationProps) {
  const { hidePageButtons, ...other } = props;

  const paginationClasses = usePaginationStyles();

  const paginationItemClasses = usePaginationItemStyles();

  const renderItem = (params: PaginationRenderItemParams) => {
    if (
      hidePageButtons &&
      params.type !== "previous" &&
      params.type !== "next"
    ) {
      return null;
    }
    if (params.type === "previous") {
      return (
        <PaginationItem
          component={PreviousButton}
          {...params}
          classes={paginationItemClasses}
        />
      );
    }
    if (params.type === "next") {
      return (
        <PaginationItem
          component={NextButton}
          {...params}
          classes={paginationItemClasses}
        />
      );
    }
    return <PaginationItem {...params} classes={paginationItemClasses} />;
  };

  return (
    <MuiPagination
      {...other}
      renderItem={renderItem}
      classes={paginationClasses}
    />
  );
}

const PreviousButton = React.forwardRef<HTMLButtonElement, any>(
  (props, ref) => (
    <button {...props} ref={ref}>
      <ChevronBigLeft fontSize="small" />
    </button>
  )
);

const NextButton = React.forwardRef<HTMLButtonElement, any>((props, ref) => (
  <button {...props} ref={ref}>
    <ChevronBigRight fontSize="small" />
  </button>
));

export default Pagination;
